<template>
  <div>
    <!-- <div class="hero simple">
      <div class="content">
        <h1 class="hero-title">{{ $t('messages.products') }}</h1>
      </div>
    </div> -->
    <!-- <div class="intro">
      <h2 class="medium">We offer a wide range of products to meet your needs.</h2>
    </div> -->
    <!-- <div style="text-align: center; height: 100%;">
      <el-image style="margin: auto; display: block; width: 60%; height: 100%" src="/static/asx/products/products_ad.png" fit="contain"></el-image>
    </div> -->
    <!-- <div class="menu_bg"></div>
    <div class="product-container">
      <div class="content">
      <h1 class="hero-title">{{ $t('messages.products') }}</h1>
      </div>
    </div> -->
    <div class="menu_bg">
    </div>
    <div class="product-container">
      <div class="content">
        <h1 class="hero-title">{{ $t('messages.products') }}</h1>
      </div>
    </div>
    <div class="slideshow__container">
      <el-carousel :interval="4000" height="500px" type="card">
        <el-carousel-item v-for="(item, index) in secondList" :key="index">
          <!-- <h3 class="medium">{{ item.name }}</h3> -->
          <el-image style="" :src="item" fit="contain"></el-image>
        </el-carousel-item>
      </el-carousel>

    </div>
    <CategoryMenu></CategoryMenu>
  </div>
</template>

<script>
import CategoryMenu from "@/components/CategoryMenu.vue";
export default {
  components: {
    CategoryMenu
  },
  data() {
    return {
      headBgUrl: "",
      bannerList: {},
      firstImageUrl: "",
      secondList: [],

    };
  },

  async mounted() {
    let res = await this.GetUrlsByHttp(this.GlobalData.homeUrl, this.GlobalData.type_product)
    console.log("res: ", res)
    if (res["1"].length != 0) {
      this.firstImageUrl = res["1"][0]
      console.log("firstImageUrl: ", this.firstImageUrl)
    }
    if (res["2"].length != 0) {
      this.secondList = res["2"]
    }
  },

};
</script>

<style scoped>
.menu_bg {
  height: 100px;
  width: 100%;
  position: relative;
  background-size: cover;
  background-color: #00579C;
}

.product-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
}

.product-container .content {

  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg,
      var(--unnamed-color-008682) 0%,
      rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg, #0077b4 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  padding: 24px 0 18px 73px;
}

.content .hero-title {
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 46px;
}

/* .hero.simple {
  height: 475px;
  width: 100%;
  position: relative;
  background-size: cover;
} */

/* .hero.simple:after {
  z-index: 1;
  content: "";
  background: rgba(0, 0, 0, 0) linear-gradient(180deg, #000000 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.5;
} */

/* @media (max-width: 1539px) {
  .hero.simple .content {
    padding: 24px 0 18px 48px;
  }
} */

/* .hero.simple .content {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg,
      var(--unnamed-color-008682) 0%,
      rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  background: rgba(0, 0, 0, 0) linear-gradient(90deg, #0077b4 0%, rgba(255, 255, 255, 0) 100%) 0% 0% no-repeat padding-box;
  padding: 24px 0 18px 73px;
}

.hero.simple .hero-title {
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 46px;
} */

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.intro {
  margin-top: 30px;
}

.slideshow__container {
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/firstLevel/products.vue